import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { useSelector } from "react-redux";
import AllRoutes from "./routes/Routes";
import { SessionProvider, useSession } from "./contexts/SessionContext";
import SessionExpiryModal from "./helpers/api/SessionExpiryModal";
import { RootState } from "./redux/store";
import "./assets/scss/Theme.scss";
import { Toaster } from "sonner";

declare global {
  interface Window {
    React: typeof React;
    ReactDOM: typeof ReactDOM;
    CheckoutModal: any;
  }
}

const App = () => {

	useEffect(() => {
		const loadCSS = () => {
			const link = document.createElement("link");
			link.rel = "stylesheet";
			link.href =
				"https://paymi-tech.github.io/zeepway-checkout-plugin/checkout-modal.min.css";
			link.id = "zeepway-css";
			document.head.appendChild(link);

			link.onload = () => {
				console.log("Zeepway CSS loaded successfully");
			};

			link.onerror = () => {
				console.error("Failed to load Zeepway CSS");
				// setModalError("Failed to load checkout styles");
			};
		};

		loadCSS();

		return () => {
			document.getElementById("zeepway-css")?.remove();
		};
	}, []);

	useEffect(() => {
		const loadScripts = async () => {
			try {
				await loadScript(
					"https://unpkg.com/react@18/umd/react.production.min.js",
					"react-script"
				);

				await loadScript(
					"https://unpkg.com/react-dom@18/umd/react-dom.production.min.js",
					"react-dom-script"
				);

				await loadScript(
					"https://paymi-tech.github.io/zeepway-checkout-plugin/checkout-modal.min.js",
					"zeepway-script"
				);

				// if (typeof window.CheckoutModal === "undefined") 
				// 	// setModalError("Checkout plugin not properly initialized");
				// else {
				// 	console.log("CheckoutModal is available:", window.CheckoutModal);
				// 	// setScriptLoaded(true);
				// }
			} catch (error) {
				// setModalError("Failed to load necessary scripts");
			}
		};

		loadScripts();

		return () => {
			document.getElementById("react-script")?.remove();
			document.getElementById("react-dom-script")?.remove();
			document.getElementById("zeepway-script")?.remove();
		};
	}, []);

	const loadScript = (src: string, id: string): Promise<void> => {
		return new Promise((resolve, reject) => {
			if (document.getElementById(id)) {
				resolve();
				return;
			}

			const script = document.createElement("script");
			script.src = src;
			script.id = id;
			script.async = false;

			script.onload = () => resolve();
			script.onerror = () => reject(new Error(`Failed to load script: ${src}`));

			document.body.appendChild(script);
		});
	};

  return (
    <SessionProvider>
      <AppComponent />

      <Toaster
        richColors
        closeButton
        position="top-right"
        offset={32}
        className="toaster group"
      />
    </SessionProvider>
  );
};

const AppComponent = () => {
  const { handleSessionExpiration } = useSession();
  const toggleDetailsEnv = useSelector(
    (state: RootState) => state.toggleReducer.toggleDetails.env
  );

  const [refreshKey, setRefreshKey] = useState<number>(0);

  useEffect(() => {
    setRefreshKey((prevKey) => prevKey + 1);
  }, [toggleDetailsEnv]);

  useEffect(() => {
    const handleEvent = () => handleSessionExpiration();
    document.addEventListener("session-expired", handleEvent);

    return () => {
      document.removeEventListener("session-expired", handleEvent);
    };
  }, [handleSessionExpiration]);

  return (
    <>
      <SessionExpiryModal />
      <AllRoutes key={refreshKey} />
    </>
  );
};

export default App;
